const people = [
  {
    id: 1,
    image:
      "https://media.istockphoto.com/photos/man-who-sheds-tears-picture-id1286801229?b=1&k=20&m=1286801229&s=170667a&w=0&h=ihKCrKNwOkvzqU3qJd6brKcf1YWEf0zX7iEeg8mP3uc=",
    quote:
      "A life spent making mistakes is not only more honorable, but more useful than a life spent doing nothing.",
  },
  {
    id: 2,
    image:
      "https://media.istockphoto.com/photos/thoughtful-man-against-black-background-picture-id1062507418?b=1&k=20&m=1062507418&s=170667a&w=0&h=gPnVIalqmlDAzei0Ekc70XTuJFC1UVdYH4paPZYc7Fw=",
    quote:
      "Google has not only reached but surpassed the 1 billion dollar evaluation mark.",
  },
  {
    id: 3,
    image:
      "https://media.istockphoto.com/photos/money-coin-in-hand-black-and-white-photo-on-black-background-black-picture-id1280271345?b=1&k=20&m=1280271345&s=170667a&w=0&h=BMfO6vZSynRANrEIvkUDuQfR4Sdku-4uXt24QABf5T0=",
    quote:
      "Father hold me close Dont let me down",
  },
  {
    id: 4,
    image:
      "https://media.istockphoto.com/photos/portrait-of-a-serious-man-in-studio-picture-id1265217247?b=1&k=20&m=1265217247&s=170667a&w=0&h=E3aDM61ZG9Csw6uHWpGhosMQQiEqdzXvCR-52wmtf_Q=",
    quote:
      "halleluyah i had breakfast with Elon Musk and we travelled to the moon to see how space is on his rocket",
  },
];

export default people;
